import { useSelector } from 'react-redux';
import { selectCurrentRegion } from '../../../../selectors/currentRegion';
import { IRegion } from '../../../../types/regions';

export const useCurrentRegion = (regionsById: Map<number, IRegion>): IRegion => {
  const currentRegion = useSelector(selectCurrentRegion);

  return regionsById.get(currentRegion.id) as IRegion;
};
